import {Injectable} from "@angular/core";
import {Apollo} from "apollo-angular";
import {Observable} from "rxjs";
import {map, take} from "rxjs/operators";
import {CheckoutUtil} from "../../../checkout/checkout-util";
import {LoggerService} from "../../common/logger.service";
import {UsanaObject} from "../../usana-object";
import {IEmailVerificationStatus} from "../email-verification-models";
import {EmailVerificationStatusQuery} from "./gql-email-verification";

@Injectable({
    providedIn: 'root'
})
export class GqlEmailVerificationService extends UsanaObject {

    constructor(private apollo: Apollo,
                loggerService: LoggerService) {
        super(loggerService);
    }

    emailVerificationStatus(vti: string): Observable<IEmailVerificationStatus> {
        return this.apollo
            .watchQuery({
                query: EmailVerificationStatusQuery,
                variables: {vti}
            })
            .valueChanges.pipe(take(1), map((data: any) => CheckoutUtil.handleApolloResponse(data, (d) => d.data.emailVerificationStatus)));
    }
}
